import { render, staticRenderFns } from "./MapPluginContainer.vue?vue&type=template&id=049128c0&scoped=true"
import script from "./MapPluginContainer.vue?vue&type=script&lang=ts"
export * from "./MapPluginContainer.vue?vue&type=script&lang=ts"
import style0 from "./MapPluginContainer.vue?vue&type=style&index=0&id=049128c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049128c0",
  null
  
)

export default component.exports